import { StepWrapper } from '../../../styles';
import { TranslatedTitle } from '../components';
import { BranchSelect, DegreeSelect, UniversitySelect } from '../components';

import { Box } from '@/components/Utils';
import { useOnboardingFormLogic } from '@/hooks';
export const DefineYourGoal = () => {
  const {
    userInfo: { isUserFromPCE }
  } = useOnboardingFormLogic();
  const objName = isUserFromPCE ? 'pceUserInfo' : 'uniUserInfo';
  return (
    <StepWrapper>
      <TranslatedTitle i18nKey="DEFINE_YOUR_GOAL" />
      <Box flexDirection="column">
        <BranchSelect objName={objName} />
        <DegreeSelect objName={objName} />
        <UniversitySelect objName={objName} />
      </Box>
    </StepWrapper>
  );
};
